module.exports = __webpack_public_path__ + "static/media/26UNRWA15.d44b54ca.jpg";